<template>
  <App>
    <AppBar style="width:100%">
      <AppTitle icon="logo-angular" name="AI 实验室" />
      <AppTabs :items="items" :actived="actived" @on-click="handleClick"/>
      <div></div>
    </AppBar>
    <AppClient style="overflow:hidden;">
    <router-view>
    </router-view>
  </AppClient>
  </App>
</template>

<script>
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppTitle from '@/components/app/title';
import AppClient from '@/components/app/client';
import AppTabs from '@/components/app/tabs';
export default {
  routerOption: {
    as_frame: true,
  },
  computed: {
    baseURL() {
      return '/core/ai';
    },
    actived() {
      const path = this.$route.path;
      const match = path.match(/^\/core\/ai\/([^\/\?]+)(?:[\/\?]|$)/);
      return match ? match[1] : '';
    },
    session() {
      return this.$store.getters['session/session'];
    },
    items() {
      const normal = [{
        icon: 'md-list',
        name: '任吾行',
        key: 'zzl',
      }, {
        icon: 'md-paper',
        name: '报告生成',
        key: 'reports',
      }, {
        icon: 'md-cube',
        name: '案例分享',
        key: 'parser',
      },{
        icon:"md-eye",
        name:'AI技能',
        key:'skill',
      },{
        icon:"md-apps",
        name:'Coze应用',
        key:'coze',
      },{
        icon:"md-apps",
        name:'个人应用',
        key:'apps'
      },{
        icon:"md-lianjieliu",
        name:'ISO',
        key:'iso'
      },{
        icon:"md-contract",
        name:'合约系统',
        key:'cm'
      }];
      const items = [...normal];
      return items;
    },
  },
  components: {App, AppBar, AppClient, AppTitle, AppTabs},
  methods: {
    handleClick(e) {
      const url = this.baseURL + '/' + e;
      this.RouteTo(url);
    },
  },
};
</script>

<style>

</style>
